"use strict";
// Copyright © Veeam Software Group GmbH
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ArrowIcon = void 0;
const react_1 = __importDefault(require("react"));
const styled_components_1 = __importDefault(require("styled-components"));
require("@veeam/components");
const helpers_1 = require("../../helpers");
const Root = styled_components_1.default.div `
  display: flex;
  transform: ${({ direction }) => helpers_1.calcArrowDirection(direction)};
`;
const Icon = styled_components_1.default.svg `
  margin: 0 auto;

  path {
    fill: #888;
  }

  rect {
    fill: none;
  }
`;
exports.ArrowIcon = react_1.default.memo((_a) => {
    var { direction } = _a, restProps = __rest(_a, ["direction"]);
    return (react_1.default.createElement(Root, Object.assign({}, restProps, { direction: direction }),
        react_1.default.createElement(Icon, { viewBox: "0 0 16 16", width: "16px", height: "16px" },
            react_1.default.createElement("g", { transform: "translate(-193 -515)" },
                react_1.default.createElement("path", { d: "M9,10V2H8v8H5l3.5,4L12,10Z", transform: "translate(210 531) rotate(180)" }),
                react_1.default.createElement("rect", { width: "16", height: "16", transform: "translate(193 515)" })))));
});
//# sourceMappingURL=ArrowIcon.js.map